module.exports = __webpack_public_path__ + "static/gallery4-95cb9296a6a4ed4a2f450609cd113049.jpg";